import { triniumApi } from '@api/Trinium/slice';
import { User, transformUserResponse } from './types';

export const usersSlice = triniumApi.injectEndpoints({
	endpoints(builder) {
		return {
			fetchUsers: builder.query<User[], { contains: string }>({
				query: ({ contains }) => {
					return {
						url: `/users`,
						params: {
							contains: contains
						}
					};
				},
				transformResponse: transformUserResponse
			})
		};
	}
});

export const { useLazyFetchUsersQuery } = usersSlice;
